// @flow
import { useContext } from 'react';

import SettingsContext from './settings-context';


const useSettingsContext = () => useContext(SettingsContext);

export default useSettingsContext;
